import { VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";

type JewelryBuilderErrorMessageProps = {
  message: string;
};

const JewelryBuilderErrorMessage = ({
  message,
}: JewelryBuilderErrorMessageProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  return (
    <VDBText color={theme["error-01"]} type={typography["Minor-R"]}>
      {message}
    </VDBText>
  );
};

export default JewelryBuilderErrorMessage;
